import { compose } from "redux";
import debounce from "lodash/debounce";
import React, { PureComponent } from "react";
import { reduxForm } from "redux-form/immutable";

import { WORK_SCHEDULE_REPORT_FORM } from "features/planner/report/report.constants";
import { WORK_SCHEDULE_REPORT_TYPE } from "features/planner/report/report.constants";
import { workScheduleReportFormOnChange } from "features/planner/report/report.actions";
import WorkScheduleYearReportHeader from "features/planner/report/workSchedule/components/year/WorkScheduleYearReportHeader";
import WorkScheduleMonthReportHeader from "features/planner/report/workSchedule/components/month/WorkScheduleMonthReportHeader";

class WorkScheduleReportDates extends PureComponent {
  render() {
    const { dates, reportType, title } = this.props;

    return (
      <>
        {reportType === WORK_SCHEDULE_REPORT_TYPE.MONTH && (
          <WorkScheduleMonthReportHeader dates={dates} title={title} />
        )}
        {reportType === WORK_SCHEDULE_REPORT_TYPE.YEAR && (
          <WorkScheduleYearReportHeader dates={dates} title={title} />
        )}
      </>
    );
  }
}

export default compose(
  reduxForm({
    destroyOnUnmount: false,
    form: WORK_SCHEDULE_REPORT_FORM.ID,
    onChange: debounce(workScheduleReportFormOnChange, 300),
  }),
)(WorkScheduleReportDates);
